import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { baseUrl } from '../../env'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: baseUrl,
  timeout: 60000 // 请求超时时间
})


// 全局 401 处理锁
let isTokenExpiredHandling = false
// 异常拦截处理器
const errorHandler = (error) => {
  if (!error || !error.response) {
    return Promise.reject(error)
  }

  const { status, data } = error.response

  // 只处理一次 401
  if (status === 401 && !isTokenExpiredHandling) {
    isTokenExpiredHandling = true

    notification.error({
      message: '登录超时',
      description: '请重新登录'
    })

    store.dispatch('Logout').finally(() => {
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    })

    // 关键：中断 Promise 链
    return new Promise(() => {})
  }

  // 非 401，正常抛给业务
  return Promise.reject(error)
}


// request interceptor
request.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['Authorization'] = token
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  // // 从 localstorage 获取 token
  // const token = storage.get(ACCESS_TOKEN)
  // console.log(response)
  // if (response.data.code == "401") {
  //   notification.error({
  //     message: '登录超时',
  //     description: '请重新登录'
  //   })
  //   if (token) {
  //     store.dispatch('Logout').then(() => {
  //       setTimeout(() => {
  //         window.location.reload()
  //       }, 1500)
  //     })
  //   }
  // }
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
